import React, { Component } from 'react'

import classes from './SetupOrg.scss'
import {
  checkValidity,
  updateFormOptions,
  updateFilterOptions,
  getPageStatus,
  updateObject,
  extractFilterOptions,
  getMultiSelectvalue,
  validateForm
} from '../../../../helpers/utils'
import moment from 'moment'
import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'
import _ from 'lodash'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Alert from '../../../../components/Alert/Alert'
// import Button from '../../../../components/UI/Button/Button'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import DataTable from '../../../../components/DataTable/DataTable'
import Form from '../../../../components/PageContent/SetupData/SetupOrg/Form/Form'
import Modal from '../../../../components/UI/Modal/Modal'
import ActionBar from '../../../../components/ActionBar/ActionBar'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import ImportModal from '../../../../components/ImportModal/ImportModal'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import { Edit, Delete, Add } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'
import Footer from '../../../../components/UI/Modal/Footer/Footer'
class SetupOrg extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    importModalOpen: false,
    importFile: '',
    action: this.props.translate('add'),
    actionRecordId: null,
    formValid: false,
    addAno: false,
    searchText: '',
    withSeq: true,
    filter: {},
    inputGroups: {
      org_code: {
        label: this.props.translate('code'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('code')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      org_name: {
        label: this.props.translate('organizationName'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('organizationName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      company_id: {
        label: this.props.translate('company'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: []
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      parent_code: {
        label: this.props.translate('parentCode'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('parentCode'),
          options: []
        },
        value: {},
        validation: false,
        valid: true,
        touched: false,
        error: null
      },
      level_id: {
        label: this.props.translate('level'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('level'),
          options: []
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      org_abbr: {
        label: this.props.translate('abbreviation'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('abbreviation')
        },
        value: '',
        validation: false,
        valid: true,
        touched: false,
        error: null
      },
      org_email: {
        label: this.props.translate('eMail'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('eMail')
        },
        value: '',
        validation: {
          required: false,
          isEmail: true
        },
        valid: true,
        touched: false,
        error: null
      },
      effective_date: {
        label: this.props.translate('effectiveDate'),
        elementType: 'datePicker',
        elementConfig: {
          type: 'text'
        },
        value: new Date(),
        validation: {
          required: true,
          type: 'date'
        },
        valid: true,
        touched: false,
        error: null
      },
      province_code: {
        label: this.props.translate('province'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('province'),
          options: []
        },
        value: {},
        validation: false,
        valid: true,
        touched: false,
        error: null
      },
      value_list_id: {
        label: this.props.translate('channel'),
        elementType: 'newmultiSelect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('channel'),
          options: []
        },
        value: [],
        validation: false,
        valid: true,
        touched: false,
        error: null
      },

      fr_group_id: {
        label: this.props.translate('forceRankGroupName'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('forceRankGroupName'),
          options: []
        },
        value: {},
        validation: false,
        valid: false,
        touched: false,
        error: null
      }
    },
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: []
        }
      },
      level_id: {
        label: this.props.translate('organizationLevel'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('organizationLevel'),
          options: []
        }
      },
      org_id: {
        label: this.props.translate('organizationName'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('organizationName'),
          options: []
        }
      }
    },
    updateProps: {
      selectedRecord: this.props.selectedRecord,
      companyOptions: this.props.companyOptions,
      appraisalTypeOptions: this.props.appraisalTypeOptions,
      parentOrgOptions: this.props.parentOrgOptions,
      levelOrgOptions: this.props.levelOrgOptions,
      provinceOptions: this.props.provinceOptions,
      channelOptions: this.props.channelOptions,
      forceRankGroupOptions: this.props.forceRankGroupOptions,
      filterCompany: this.props.filterCompany,
      filterOrg: this.props.filterOrg,
      filterLevel: this.props.filterLevel
    }
  }

  rowActions = [
    {
      icon: () => <Add />,
      tooltip: this.props.translate('add') + this.props.translate('organization'),
      onClick: () => this.openModalHandler('add'),
      isFreeAction: true,
      disabled: !this.props.pagePermission.is_add
    },
    {
      icon: () => <Edit fontSize={'small'} />,
      tooltip: this.props.translate('edit') + this.props.translate('organization'),
      onClick: (event, rowData) => this.openModalHandler('edit', rowData.org_id),
      disabled: !this.props.pagePermission.is_edit
    },
    {
      icon: () => <Delete fontSize={'small'} />,
      tooltip: this.props.translate('delete') + this.props.translate('organization'),
      onClick: (event, rowData) => this.openModalHandler('delete', rowData.org_id),
      disabled: !this.props.pagePermission.is_delete
    }
  ]

  tableStructure = [
    {
      field: 'index',
      title: '#',
      width: 70
    },
    { field: 'org_code', title: this.props.translate('code'), type: 'string' },
    { field: 'org_name', title: this.props.translate('organizationName'), type: 'string' },
    { field: 'company_name', title: this.props.translate('company'), type: 'string' },
    { field: 'level_name', title: this.props.translate('level'), type: 'string' },
    { field: 'effective_date', title: this.props.translate('effectiveDate'), type: 'string' }
  ]

  componentDidMount() {
    this.props.fetchOptions()
    this.props.fetchOrg()
  }
  componentDidUpdate(prevprops) {
    if (prevprops.success !== this.props.success && this.props.success) {
      this.clearModal()
    }
  }
  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    let { updateProps } = state
    const updateOptions = (stateId, propsId, attr) => {
      const inputGroups = state.inputGroups
      const targetLevelItem = inputGroups[stateId]
      let [attrId, attrName] = attr

      updatedState = updateObject(updatedState, {
        inputGroups: updateObject(inputGroups, {
          [stateId]: updateFormOptions(props[propsId], targetLevelItem, attrId, attrId, attrName)
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    const updateFilter = (stateId, propsId, attr) => {
      let [attrId, attrName] = attr
      let value = state.filterControls[stateId].value
      if (props[propsId].length === 0) {
        value = 'No Data'
      }
      updatedState = updateObject(updatedState, {
        filterControls: updateObject(state.filterControls, {
          [stateId]: updateFilterOptions(
            props[propsId],
            state.filterControls[stateId],
            attrId,
            attrId,
            attrName,
            null,
            null,
            value
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
   
    if (props.selectedRecord !== updateProps.selectedRecord && props.selectedRecord) {
      let newOrgData = Object.entries(state.inputGroups).reduce(
        (organizationGroups, organization) => {
          let [organizationKey, organizationAttrs] = organization
          let value = ''
          let valid = false
          let touched = false
          let errorMessage = null
          if (!organizationAttrs.validation || !organizationAttrs.validation.required) {
            valid = true
          }

          if (organizationAttrs.elementType === 'checkbox') {
            value = 0
          }
          if (organizationKey === 'value_list_id') {
            value = getMultiSelectvalue(
              props.selectedRecord.org_channel,
              state.inputGroups[organizationKey].elementConfig.options,
              'channel_id'
            )
          }
          if (props.selectedRecord && props.selectedRecord[organizationKey]) {
            value = props.selectedRecord[organizationKey]
            if (organizationAttrs.elementType === 'datePicker') {
              value = new Date(props.selectedRecord[organizationKey])
            }
            let { isValid, error } = checkValidity(
              value,
              organizationAttrs.validation,
              organizationAttrs.label
            )
            if (organizationAttrs.elementType === 'newselect') {
              value = state.inputGroups[organizationKey].elementConfig.options.find(
                res => res.value === value
              )
            }
            if (organizationKey === 'company_id') {
              props.fetchOrgLevelOptions({ company_id: value.value })
              props.fetchParentOptions({ company_id: value.value })
              props.fetchForceRankGroup({ company_id: value.value })
            }

            valid = isValid
            errorMessage = error
          }
         
          const newOrgAttrs = {
            ...organizationAttrs,
            value: value,
            valid: valid,
            error: errorMessage,
            touched: touched
          }
          return updateObject(organizationGroups, { [organizationKey]: { ...newOrgAttrs } })
        },
        {}
      )

     updatedState = {
        ...updatedState,
        inputGroups: newOrgData,
        formValid: true,
        updateProps: {
          ...updateProps,
          selectedRecord: props.selectedRecord
        }
      }
    }

    if (_.isEmpty(props.forceRankGroupOptions) !== _.isEmpty(updateProps.forceRankGroupOptions)){
      updateOptions('fr_group_id', 'forceRankGroupOptions', ['fr_group_id', 'fr_group_name' ])
    }

    if (props.forceRankGroupOptions !== updateProps.forceRankGroupOptions) {
      updateOptions('fr_group_id', 'forceRankGroupOptions', ['fr_group_id', 'fr_group_name' ])
    }else if (_.isEmpty(props.forceRankGroupOptions) && props.forceRankGroupOptions === updateProps.forceRankGroupOptions) {
      updateOptions('fr_group_id', 'forceRankGroupOptions', ['fr_group_id', 'fr_group_name'])
    }

    if (props.companyOptions !== updateProps.companyOptions) {
      updateOptions('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' }
      ])
    }
    if (props.parentOrgOptions !== updateProps.parentOrgOptions) {
      updateOptions('parent_code', 'parentOrgOptions', [
        'org_code',
        { code: 'org_code', name: 'org_name' }
      ])
    }
    if (props.levelOrgOptions !== updateProps.levelOrgOptions) {
      updateOptions('level_id', 'levelOrgOptions', ['level_id', 'level_name'])
    }
    if (props.provinceOptions !== updateProps.provinceOptions) {
      updateOptions('province_code', 'provinceOptions', ['province_code', 'province_name_display'])
    }
    if (props.channelOptions !== updateProps.channelOptions) {
      updateOptions('value_list_id', 'channelOptions', [
        'value_list_id',
        { code: 'value_list_code', name: 'value_list_name' }
      ])
    }
   
    if (props.filterCompany !== updateProps.filterCompany) {
      updateFilter('company_id', 'filterCompany', [
        'company_id',
        { code: 'company_code', name: 'company_name' }
      ])
    }
    if (props.filterOrg !== updateProps.filterOrg) {
      updateFilter('org_id', 'filterOrg', ['org_id', { code: 'org_code', name: 'org_name' }])
    }
    if (props.filterLevel !== updateProps.filterLevel) {
      updateFilter('level_id', 'filterLevel', ['level_id', 'level_name'])
    }
    return updatedState
  }

  onPageChangeHandler = (e, page) => {
    const pageOptions = {
      page: page,
      perPage: this.props.pagination.perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchOrg(payload)
  }

  onPerPageChangeHandler = perPage => {
    const pageOptions = {
      page: this.props.pagination.currentPage,
      perPage: perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchOrg(payload)
  }

  searchInputChangeHandler = e => {
    const searchText = e.target.value
    this.setState({
      searchText: searchText
    })
  }
  clearInput = () => {
    let newFormData = Object.entries(this.state.inputGroups).reduce((formGroups, form) => {
      let [formKey, formAttrs] = form
      let newFormAttrs
      switch (formKey) {
        case 'effective_date':
          newFormAttrs = {
            ...formAttrs,
            value: new Date()
          }
          break
        default:
          newFormAttrs = {
            ...formAttrs,
            value: ''
          }
          break
      }

      return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
    }, {})
    this.setState({ inputGroups: newFormData, formValid: false })
  }
  openModalHandler = (action, recordId) => {
    if (recordId && action === 'edit') {
      this.props.fetchOrgById(recordId)
    }
    this.setState({
      action: action,
      actionRecordId: recordId
    })

    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else {
      this.props.fetchOptions()
      this.openModal()
    }
  }

  openModal = () => {
    this.setState({
      modalOpen: true
    })
  }

  closeModal = () => {
    if (this.state.action === 'edit') {
      this.clearModal()
    } else {
      this.setState({
        modalOpen: false
      })
    }
  }
  clearModal = () => {
    this.clearInput()
    this.props.clearSelectedRecord()
    if (this.state.addAno) {
      this.setState({
        actionRecordId: null,
        formValid: false,
        addAno: false
      })
    } else {
      this.setState({
        actionRecordId: null,
        formValid: false,
        modalOpen: false
      })
    }
  }

  downloadHandler = () => {
    this.props.downloadTemplate(this.state.filter)
  }

  exportHandler = () => {
    this.props.exportOrg(this.state.filter)
  }
  openImportModal = () => {
    this.setState({
      importModalOpen: true
    })
  }

  closeImportModal = () => {
    this.setState({
      importModalOpen: false,
      importFile: ''
    })
  }

  fileChangeHandler = event => {
    const file = event.target.files[0]
    this.setState({
      importFile: file
    })
  }

  fileSubmitHandler = () => {
    this.props.importOrg(this.state.importFile, this.state.filter)
    this.closeImportModal()
  }

  organizationSubmitHandler = type => {
    let organizationData = Object.entries(this.state.inputGroups).reduce(
      (organizationData, organizationEntry) => {
        let [organizationKey, organizationAttrs] = organizationEntry
        let value = ''
        if (organizationAttrs.elementType === 'datePicker') {
          value = moment(organizationAttrs.value).format('YYYY-MM-DD')
        } else if (organizationAttrs.elementType === 'newselect') {
          value = organizationAttrs.value?.value
        } else if (organizationAttrs.elementType === 'newmultiSelect') {
          if (organizationKey === 'value_list_id') {
            organizationKey = 'channel_data'
          }
          value = organizationAttrs.value.map(item => item.value)
        } else {
          value = organizationAttrs.value
        }
        return updateObject(organizationData, { [organizationKey]: value })
      },
      {}
    )

    if (this.state.action === 'add') {
      this.props.createOrg({ ...organizationData }, getPageStatus(this.props.pagination, false))
      if (type === 'saveAno') {
        this.setState({
          addAno: true
        })
      }
    } else if (this.state.action === 'edit') {
      this.props.updateOrg(
        this.state.actionRecordId,
        { ...organizationData },
        getPageStatus(this.props.pagination, false)
      )
    }
  }

  inputChangeHandler = (organizationKey, event) => {
    const inputGroup = this.state.inputGroups
    const organizationItem = inputGroup[organizationKey]
    let inputValue = ''
    switch (organizationItem.elementType) {
      case 'textEditor':
        inputValue = event.target.getContent()
        break
      case 'newselect':
        inputValue = event
        break
      case 'newmultiSelect':
        inputValue = event
        break
      case 'checkbox':
        inputValue = organizationItem.value === 0 ? 1 : 0
        break
      case 'datePicker':
        inputValue = event
        break
      default:
        inputValue = event.target.value
        break
    }
    if (organizationKey === 'company_id') {
      this.props.fetchOrgLevelOptions({ company_id: event.value })
      this.props.fetchParentOptions({ company_id: event.value })
      this.props.fetchForceRankGroup({ company_id: event.value })
      let parent_code = inputGroup.parent_code
      let level_id = inputGroup.level_id
      let fr_group_id = inputGroup.fr_group_id
      this.setState({
        inputGroups: updateObject(inputGroup, {
          parent_code: {
            ...parent_code,
            value: {}
          },
          level_id: {
            ...level_id,
            value: {}
          },
          fr_group_id: {
            ...fr_group_id,
            value: {}
          }
        })
      })
    }
    const { isValid, error } = checkValidity(
      inputValue,
      organizationItem.validation,
      organizationItem.label
    )

    const updatedOrgItem = {
      ...organizationItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }
    const updateGroup = updateObject(inputGroup, { [organizationKey]: updatedOrgItem })
    let formIsValid = true
    Object.values(updateGroup).map(attr => {
      return (formIsValid = formIsValid && attr.valid)
    })
    this.setState({
      inputGroups: updateObject(this.state.inputGroups, { [organizationKey]: updatedOrgItem }),
      formValid: formIsValid
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false
    })
  }

  openConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: true
    })
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    let filterControls = this.state.filterControls

    Object.entries(filterControls).map((data, key) => {
      let [datakey] = data

      return (filterControls = {
        ...filterControls,
        [datakey]: { ...filterControls[datakey], value: '' }
      })
    })

    this.props.fetchFilter()

    this.setState({
      filterModalOpen: true,
      filterControls: filterControls,
      filter: []
    })
  }

  deleteRecord = () => {
    const recordId = this.state.actionRecordId
    this.props.deleteOrg(recordId, getPageStatus(this.props.pagination, true))

    this.closeConfirmationModal()
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]

    this.setState(
      {
        filterControls: updateObject(this.state.filterControls, {
          [itemKey]: {
            ...filterItem,
            value: filterValue
          }
        }),
        filter: { ...this.state.filter, [itemKey]: filterValue?.value }
      },
      () => {
        this.props.fetchFilter(this.state.filter)
      }
    )
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    let param = { ...this.state.filter, page: 1, perPage: this.props.pagination.perPage }
    this.props.fetchOrg(param)
    this.closeFilterModal()
  }
  
  render() {
    // const buttonGroups = (
    //   <div className={classes.ButtonGroup}>
    //     <span className={classes.Button}>
    //       <Button
    //         color={'primary'}
    //         clicked={this.organizationSubmitHandler}
    //         disabled={!this.state.formValid}>
    //         {this.props.translate('save')}
    //       </Button>
    //     </span>
    //     <span className={classes.Button}>
    //       <Button color={'default'} clicked={this.clearModal}>
    //         {this.props.translate('cancel')}
    //       </Button>
    //     </span>
    //   </div>
    // )
    const footer = (
      <Footer
        save={() => this.organizationSubmitHandler('save')}
        another={() => this.organizationSubmitHandler('saveAno')}
        showAnother={this.state.action === 'add'}
        cancel={() => this.closeModal()}
        disable={!validateForm(this.state.inputGroups)}
      />
    )
    let importDisabled = true
    const pagePermission = this.props.pagePermission

    if (pagePermission.is_add && pagePermission.is_edit) {
      importDisabled = false
    }
    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <ImportModal
          title={this.props.translate('organization')}
          open={this.state.importModalOpen}
          cancelled={this.closeImportModal}
          fileChanged={this.fileChangeHandler}
          fileSubmit={this.fileSubmitHandler}
          selectedFile={this.state.importFile}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
        />
        <Alert />
        
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={this.props.translate(this.state.action) + this.props.translate('organization')}
          backdropClicked={this.closeModal}
          footer={footer}>
          <div className={classes.ModalBody}>
            <Form form={this.state.inputGroups} inputChanged={this.inputChangeHandler} />
          </div>
        </Modal>
        <Card>
          <CardHeader>
            <ActionBar
              exporting={this.exportHandler}
              importing={this.openImportModal}
              downloading={this.downloadHandler}
              filtering={this.openFilterModal}
              importDisabled={importDisabled}
            />
          </CardHeader>
          <CardBody>
            <DataTable
              tableTitle={this.props.translate('organization')}
              data={this.props.data}
              structure={this.tableStructure}
              loading={this.props.loadingQueue.includes('record')}
              pagination={this.props.pagination}
              pageChange={this.onPageChangeHandler}
              perPageChange={this.onPerPageChangeHandler}
              rowActions={this.rowActions}
            />
          </CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.organization.pagination,
    data: state.organization.records,
    loading: state.organization.loading,
    filterLoading: state.organization.filterLoading,
    success: state.organization.success,
    selectedRecord: state.organization.selectedRecord,
    companyOptions: state.organization.company,
    appraisalTypeOptions: state.organization.appraisalType,
    parentOrgOptions: state.organization.parent,
    levelOrgOptions: state.organization.level,
    provinceOptions: state.organization.province,
    channelOptions: state.organization.channel,
    forceRankGroupOptions: state.organization.forceRankGroup,
    filterCompany: state.organization.company,
    filterOrg: state.organization.filterOrg,
    filterLevel: state.organization.filterLevel,
    loadingQueue: state.organization.loadingStates
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchOrg: filterOptions => dispatch(actions.fetchOrg(filterOptions)),
    fetchOrgById: recordId => dispatch(actions.fetchOrgById(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedOrgRecord()),
    createOrg: (recordData, page) => dispatch(actions.createOrg(recordData, page)),
    updateOrg: (recordId, recordData, page) =>
      dispatch(actions.updateOrg(recordId, recordData, page)),
    deleteOrg: (recordId, page) => dispatch(actions.deleteOrg(recordId, page)),
    importOrg: (importFile, filterOptions) =>
      dispatch(actions.importOrg(importFile, filterOptions)),
    exportOrg: filterOptions => dispatch(actions.exportOrg(filterOptions)),
    downloadTemplate: filterOptions => dispatch(actions.downloadOrgTemplate(filterOptions)),
    fetchCompanyOptions: recordId => dispatch(actions.fetchCompanyOptions(recordId)),
    fetchOptions: () => {
      dispatch(actions.fetchCompanyOptions())
      dispatch(actions.fetchOrgLevelOptions())
      dispatch(actions.fetchParentOptions())
      dispatch(actions.fetchProvinceOptions())
      dispatch(actions.fetchOrgChannelOptions())
    },
    fetchOrgLevelOptions: filter => dispatch(actions.fetchOrgLevelOptions(filter)),
    fetchParentOptions: filter => dispatch(actions.fetchParentOptions(filter)),
    fetchForceRankGroup: filter =>
      dispatch(actions.fetchForceRankGroupFilterForceRankGroup(filter)),
    fetchFilter: filter => {
      dispatch(actions.fetchCompanyOptions(filter))
      dispatch(actions.fetchOrgFilterOrg(filter))
      dispatch(actions.fetchOrgFilterLevel(filter))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(SetupOrg))
